import { Link } from "react-router-dom";
import { updateList } from "@/mocks/updates";
import SectionHeading from "@/components/base/SectionHeading";

export default function UpdateFeed() {
  const items = updateList.slice(0, 6);

  return (
    <section className="mt-14 bg-background-100 py-14">
      <div className="page-wrap">
        <SectionHeading
          eyebrow="追番日历"
          title="动画更新速递"
          description={`按最近更新时间排序，共 ${items.length} 部作品有新集上线。`}
          action={
            <Link
              to="/updates"
              className="inline-flex items-center gap-1 whitespace-nowrap rounded-md border border-background-200 bg-background-50 px-4 py-2 text-sm font-medium text-foreground-700 transition-colors hover:border-secondary-300 hover:text-secondary-700"
            >
              查看全部更新
              <i className="ri-arrow-right-line"></i>
            </Link>
          }
        />

        <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
          {items.map((item) => (
            <Link
              key={item.id}
              to={`/updates/${item.id}`}
              className="group flex items-center gap-4 rounded-lg border border-background-200 bg-background-50 p-3 transition-colors hover:border-secondary-300 md:p-4"
            >
              <div className="h-16 w-24 shrink-0 overflow-hidden rounded-md bg-background-200 md:h-20 md:w-32">
                <img
                  src={item.cover}
                  alt={`${item.title} 封面`}
                  title={`${item.title} 动画更新 - 漫蛙2`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="min-w-0 flex-1">
                <div className="flex items-center gap-2">
                  <h3 className="truncate text-sm font-semibold text-foreground-950 transition-colors group-hover:text-secondary-700 md:text-base">
                    {item.title}
                  </h3>
                  <span className="shrink-0 rounded-md bg-accent-100 px-2 py-0.5 text-[11px] font-semibold text-accent-800">
                    EP.{item.episode}
                  </span>
                </div>
                <p className="mt-1 line-clamp-1 text-xs text-foreground-600">{item.description}</p>
                <div className="mt-1.5 flex items-center gap-2 text-xs text-foreground-400">
                  <i className="ri-time-line"></i>
                  {item.updatedAt}
                  <span>·</span>
                  <span>{item.weekday}更新</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}